// extracted by mini-css-extract-plugin
export var imgPosition = "image-only-module--img-position--dafff";